module.exports = __webpack_public_path__ + "static/media/98.a812eb9a.png";